import { render } from "./FruitListItem.vue?vue&type=template&id=7dc8f566"
import script from "./FruitListItem.vue?vue&type=script&lang=js"
export * from "./FruitListItem.vue?vue&type=script&lang=js"
script.render = render

export default script